import { render, staticRenderFns } from "./ShareLanding.vue?vue&type=template&id=b0220f62&scoped=true"
import script from "./ShareLanding.vue?vue&type=script&lang=js"
export * from "./ShareLanding.vue?vue&type=script&lang=js"
import style0 from "./ShareLanding.vue?vue&type=style&index=0&id=b0220f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0220f62",
  null
  
)

export default component.exports